import React, { useEffect } from 'react';

import { Autocomplete } from '@metarouter-private/mr-mui';

import {
  useEventDebuggerTableContext,
  FILTER_KEYS,
} from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';

const PLACEHOLDER = 'Search by Event Name';

export default function EventNameSearchBar(props) {
  const { cluster, filterOptions, filterOptionsLoading, updateFilter, filters } = useEventDebuggerTableContext();

  const onSearch = (_, value) => {
    updateFilter({ [FILTER_KEYS.EVENT_NAMES]: value });
  };

  useEffect(() => {
    return () => {
      updateFilter({ [FILTER_KEYS.EVENT_NAMES]: [] });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Autocomplete
      {...props}
      multiple
      options={filterOptions?.eventNames || []}
      value={filters[FILTER_KEYS.EVENT_NAMES]}
      onChange={onSearch}
      disabled={!cluster || filterOptionsLoading}
      placeholder={PLACEHOLDER}
      limitTags={2}
      ChipProps={{ variant: 'soft' }}
      key={`${cluster}-event-names`}
    />
  );
}
